import { StrictMode, Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router';
import { Provider } from 'react-redux';


import { ThemeProvider } from './theme/ThemeProvider';
import { NotificationProvider } from './components/NotificationProvider';
import { router } from './routes';
import { store } from './app/store';
import Loader from './components/loader';

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <ThemeProvider>
        <NotificationProvider>
          <Suspense fallback={<Loader />}>
            <RouterProvider router={router}></RouterProvider>
          </Suspense>
        </NotificationProvider>
      </ThemeProvider>
    </Provider>
  </StrictMode>,
);

const SPLASH_MIN_MS = 3000;
const hideSplash = () => {
  const splash = document.getElementById('splash');
  if (!splash) return;
  splash.classList.add('splash--hidden');
  setTimeout(() => splash.remove(), 500);
};
requestAnimationFrame(() =>
  requestAnimationFrame(() => {
    const wait = Math.max(0, SPLASH_MIN_MS - performance.now());
    if (wait > 0) {
      setTimeout(hideSplash, wait);
    } else {
      hideSplash();
    }
  }),
);
